var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "system-user-list" },
    [
      _c("div", { staticClass: "page-title bottom-line" }, [
        _vm._v(" " + _vm._s(_vm.$t("menu.static_qr")) + " "),
      ]),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
              on: { click: _vm.showAddModal },
            },
            [_vm._v(_vm._s(_vm.$t("components.create")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("acceptPayments.qr_thumbnail"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "100px", cursor: "pointer" },
                          attrs: { src: scope.row.qr_code_img_pure_oss_url },
                          on: {
                            click: function ($event) {
                              return _vm.showDetailModal(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("acceptPayments.static_qr_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  name: "Transaction_Manage_Payin",
                                  query: { qrNo: scope.row.qr_no },
                                })
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.qr_no))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("acceptPayments.tag"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.tag) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("system.remark"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "grid",
                              "grid-template-columns": "1fr 25px",
                              gap: "10px",
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                            _c("svg-icon", {
                              staticStyle: { width: "15px", margin: "0" },
                              attrs: {
                                slot: "reference",
                                "class-name": "icon-function",
                                "icon-class": "operation-edit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickEditRemark(scope.row)
                                },
                              },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.create_time) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "acceptPayments.view_transaction_details"
                                        )
                                      )
                                  ),
                                ]),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailBtn(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.download"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name":
                                  "icon-function operation-download",
                                "icon-class": "operation-download",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDowmloadBtn(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("payment_links.copy_link")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function mb-10 copy-btn",
                                "icon-class": "icon-copy",
                                "data-clipboard-text":
                                  scope.row.qr_code_img_pure_oss_url,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickCopyBtn(".copy-btn", "Link")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.confirm },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("acceptPayments.qr_code_detail"),
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "item-box" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("acceptPayments.qr_link"))),
            ]),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "300px",
                      "white-space": "nowrap",
                      overflow: "hidden",
                      "text-overflow": "ellipsis",
                    },
                  },
                  [_vm._v(_vm._s(_vm.form.qr_code_img_pure_oss_url))]
                ),
                _c("svg-icon", {
                  staticStyle: { margin: "0" },
                  attrs: {
                    "class-name": "icon-function copy-btn2",
                    "icon-class": "icon-copy",
                    "data-clipboard-text": _vm.form.qr_code_img_pure_oss_url,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickCopyBtn(".copy-btn2", "Link")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "item-box" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("acceptPayments.tag"))),
            ]),
            _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(_vm._s(_vm.form.tag))]),
            ]),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "align-items": "center",
              },
            },
            [
              _c("img", {
                staticStyle: { width: "300px" },
                attrs: { src: _vm.form.qr_code_img_pure_oss_url },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { type: "primary", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onClickDowmloadBtn(_vm.form)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("acceptPayments.download_qr_code")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("CreateStaticQrModal", {
        ref: "createStaticQrModal",
        on: { updateTableData: _vm.getTableData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }